import axios from "axios";
import { persistor, store } from "../store";
import { userLogout } from "../Actions/AuthAction";
import { removeUserDetailData } from "../Actions/UserDetailAction";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
});

// const api = axios.create({
//   baseURL: 'http://localhost:4500'
// })

api.interceptors.request.use(
  async (config) => {

    const token = store?.getState()?.auth.token;
    // if (
    //   config.url.includes("/login") ||
    //   config.url.includes("/register") ||
    //   config.url.includes("/verify") ||
    //   config.url.includes("/resend-otp") ||
    //   config.url.includes("/forgot-password") ||
    //   config.url.includes("/reset-password") ||
    //   config.url.includes("/getcms") ||
    //   config.url.includes("/cmscontent") ||
    //   config.url.includes("/getsite") ||
    //   config.url.includes("/getall") ||
    //   config.url.includes("/getsymbol/groupslug") ||
    //   config.url.includes("/accounttype/gettype") ||
    //   config.url.includes("/auth-verify") ||
    //   config.url.includes("/tradepair/spot/tradepair") ||
    //   config.url.includes("/tradepair/gettopmarketlist") ||
    //   config.url.includes("/tradepair/gettradepair") ||
    //   config.url.includes("/tradepair/getspottradepair") ||
    //   config.url.includes("/tradepair/getnewtradepair") ||
    //   config.url.includes("/tradepair/spot/ticker")
    // ) {
    //   return config;
    // }

    // config.headers['Authorization'] = `Bearer 12e58a5ef899f328774841311bec1134054b7f27d77c58981db6f3e51cf441140aab9b527f018d4c14337e74996ec9a24be270787fb76e2b02471f8044c2fc1e5a753d11a6bc1957c9e414ff52453e260afecbf5b19dc1362c2e322c167ad800d0a14b67607d9f173025a9e0926f7be1e248722e95ddff4ecb670ded0a27ac6f56035c22a43766651720aedf6e6f1289fd60e88269c7c8bf85fa26f16b15bf431fea9d881a433f6d1386b68b82742b424f6bc59e1fa4f81f5ffecc4e97d30c1cb64eb22d3eb5fe7e1facc270228aa9859c455bbf9740993a3c5876e37577c1ddd8de2996ad29b46c05316fd12ab083d509a8a422e844f925b24cab17664a107d`;
    if (token && token !== undefined && token !== "undefined") {
      config.headers['Authorization'] = `Bearer ${token}`;
      return config;
    } else {
      return config
      // localStorage.clear();
      // store.dispatch(userLogout());
      // store.dispatch(removeUserDetailData());

      // window.location.href = "/login";
      // return Promise.reject("No token found");
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);


api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      localStorage.removeItem("Token");
      persistor.purge();
      localStorage.clear();
      store.dispatch(userLogout());
      store.dispatch(removeUserDetailData());
      // window.location.href = '/login';
    }

    return Promise.reject(error);
  }
);

export default api;
